import { render, staticRenderFns } from "./modalAceptarAfiliado.vue?vue&type=template&id=13d823ea&scoped=true&"
import script from "./modalAceptarAfiliado.vue?vue&type=script&lang=js&"
export * from "./modalAceptarAfiliado.vue?vue&type=script&lang=js&"
import style0 from "./modalAceptarAfiliado.vue?vue&type=style&index=0&id=13d823ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d823ea",
  null
  
)

export default component.exports